import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
/** A label/value summary table. */
function SummaryTable(_ref) {
  var rows = _ref.rows;
  return /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden rounded-sds-200 border border-sds-base-default"
  }, rows.map(function (row, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: row.label,
      className: "flex items-start justify-between gap-4 px-4 py-3 ".concat(index % 2 === 0 ? "bg-sds-base-secondary" : "bg-sds-base-default")
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-style-body-small text-sds-base-secondary"
    }, row.label), /*#__PURE__*/React.createElement("span", {
      className: "text-style-body-small-strong text-sds-base-default text-right"
    }, row.value));
  }));
}

/** Review step: a warning plus a summary of what will be written to the EMR. */
export function ReviewStep(_ref2) {
  var action = _ref2.action,
    encounterRows = _ref2.encounterRows,
    docTitle = _ref2.docTitle,
    docRows = _ref2.docRows;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 rounded-sds-200 border border-sds-attention-secondary bg-sds-attention-tertiary p-4 text-sds-attention-secondary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTriangleExclamation,
    className: "mt-0.5 h-4 w-4 flex-shrink-0"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small"
  }, t("submit_warning", {
    defaultValue: "Review carefully — this will be submitted to the EMR and cannot be undone here."
  }))), action === "create" && encounterRows.length ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-style-body-small-strong text-sds-base-default"
  }, t("encounter_details", {
    defaultValue: "Encounter details"
  })), /*#__PURE__*/React.createElement(SummaryTable, {
    rows: encounterRows
  })) : null, docTitle && docRows.length ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-style-body-small-strong text-sds-base-default"
  }, docTitle), /*#__PURE__*/React.createElement(SummaryTable, {
    rows: docRows
  })) : null);
}